/** @format */
import { css } from 'styled-components';

export const styles = () => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--colors-surface-primary);
    z-index: 10;
    overflow: auto;

    .filter-content {
        position: relative;
        height: 100%;
        overflow: scroll;
        padding-bottom: 6.2rem; /* The height of the sticky button container */
    }

    .filter-header {
        display: flex;
        flex-wrap: wrap;
        padding: var(--layout-spacing-24) var(--layout-spacing-12) 1.6rem;
        border-bottom: 1px solid var(--colors-border-light);
        position: relative;
    }

    .filter-header-title {
        width: 100%;
        padding-right: 5rem;
        margin-bottom: var(--layout-spacing-12);
    }

    .filter-header-results {
        margin: 0;
        font-size: 1.2rem;
        flex-grow: 1;
        margin-right: var(--layout-spacing-12);
        color: var(--colors-text-primary);

        strong {
            color: var(--colors-text-secondary);
        }
    }

    .filter-header-close {
        position: absolute;
        top: 0;
        right: 0;
        padding: var(--layout-spacing-12);
    }

    .filter-buttons {
        display: flex;
        padding: var(--layout-spacing-12);
        justify-content: space-between;

        background: var(--colors-surface-primary);

        position: fixed;
        bottom: 0;
        z-index: 50;
        width: 100%;

        .filter-button {
            width: calc(50% - 0.4rem);
        }
    }

    .extra-node-clear {
        font-weight: 300;
    }

    .extra-node-count {
        font-size: 1.2rem;
        color: var(--colors-text-primary);
        font-weight: 300;
    }

    .filter-accordion .title {
        font-size: 1.6rem;
        align-items: center;
    }
`;
